<template>
  <div class="container">
    <mt-swipe class="myHeight" :auto="0">
      <mt-swipe-item  v-for="(item,index) of imgList" :key="index" >
          <img  class="img" :src="item" alt="">
      </mt-swipe-item>
    </mt-swipe>
    <div v-show="isShow" class="button prev" >
      <img class="icon" src="../../assets/prev.png" alt="">
    </div>
    <div v-show="isShow" class="button next">
      <img class="icon" src="../../assets/next.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props:["imgList"],
  data () {
    return {
      isShow:false
    }
  },
  mounted(){
     var mySwiper = new Swiper('.swiper-container', {
          autoplay:true,
          loop:true
        })
  },
  methods:{
      handleChange(index) {
        console.log(index)
      },
      getIndex(index){
        console.log(index)
      }
  },
  components:{
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container{
    height:100vh;
    width: 100vw;
    background:#020003;
    position: relative;
  }
  .myHeight{
    height:100%;
    /* background:#f00; */
  }
  mt-swipe-item{
     position:relative;
  }
  .img{
    width:100%;
    position:absolute;
   top:50%;
   left:50%;
   transform: translate(-50%,-50%);
  }
  .container /deep/ .mint-swipe-indicator{
    background:#333;
    opacity: 1;
  }
  .container /deep/ .mint-swipe-indicator.is-active{
    background:#fff;
    width:10px; 
    height:10px;
    opacity: 1;
  }
  .button{
    width:10%;
    border-radius:50%;
    position: absolute;
    top:50%;
    transform: translate(0,-50%);
  }
  .prev{
    left:10px;
  }
  .next{
    right:10px;
  }
 .icon{
   width:100%;
   opacity: 0.7;
 }

</style>



<!--
<template>
<div class="container" >
<div class="swiper-container">
<div class="swiper-wrapper">
<div class="swiper-slide">< img src="../assets/logo.png"/></div>
<div class="swiper-slide">Slide 3</div>
<div class="swiper-slide">< img src="../assets/logo.png"/></div>
</div>
<!-- 如果需要分页器 -->
<!--<div class="swiper-pagination"></div>
<!-- 如果需要导航按钮 -->
<!--<!--<div v-show="isShow" class="swiper-button-prev"></div>
<div v-show="isShow" class="swiper-button-next"></div>
<!-- 如果需要滚动条 -->
<!--<div class="swiper-scrollbar"></div>-->
<!--</div>
</div>
</template>

<script>
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
export default {
data () {
return {
url:"",
isShow:true
}
},
created(){
},
mounted(){ 
if(/Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
navigator.userAgent)) {
this.isShow=false;
console.log(this.isShow)
} 
new Swiper ('.swiper-container', {
//是否自动轮播
// autoplay:true,
//形成环路（即：可以从最后一张图跳转到第一张图 
loop: true, 
// 如果需要分页器 
pagination: {
el:'.swiper-pagination'
}, 
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
}, 
})
},
components:{
},
}
</script>
-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- 
<style scoped>
.container{
background:#020003;
height:100vh;
}
.swiper-container{
height:100%;
}
.swiper-wrapper /deep/ .swiper-slide{
display: flex;
align-items: center;
}
.swiper-slide>img{
width: 100%;
}

.swiper-pagination /deep/ .swiper-pagination-bullet{
background:#333;
opacity: 1;
}
.swiper-pagination /deep/ .swiper-pagination-bullet-active{
background:#fff;
}
</style>
-->



// WEBPACK FOOTER //
// src/components/common/images.vue